export const CREATE = "CREATE_PROMO";

export const READ = "READ_PROMO";

export const UPDATE = "UPDATE_PROMO";

export const DELETE = "DELETE_PROMO";